import React from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import ProductCard from '@/components/user/orders/product-card';
import { formatDate } from '@/helpers/common';
import { handleOrderStatus, handleQtyText } from '@/utils/orders';
import useOrder from '@/hooks/orders/useOrders';

const OrderCard = ({ order, fromDetails = false, mage }) => {
  const t = useTranslations('user');
  const locale = useLocale();

  const Wrapper = fromDetails ? 'div' : Link;
  const wrapperProps = fromDetails
    ? { className: 'border-border rounded-lg border' }
    : {
        href: `/user/orders/${order?.entity_id}`,
        className: 'rounded-lg ',
      };

  const orderStatusBg = `${handleOrderStatus(order?.state, locale)?.color}`;

  const { items } = useOrder(order);

  return (
    <Wrapper {...wrapperProps}>
      <div className='relative flex items-center justify-between rounded-t-lg bg-[#14B2E2] p-4 text-white'>
        <div>
          <p className='text-sm md:text-base'>{t('order_placed_key')}</p>
          <p className='text-sm font-semibold md:text-base'>
            {formatDate(order.created_at, 'M d, yyyy', '', 'date', locale)}.
          </p>
        </div>
        <div>
          <p className='text-sm md:text-base'>{t('order_number_key')}</p>
          <p className='text-sm font-semibold md:text-base'>
            {order?.increment_id || ''}
          </p>
        </div>
        <div className='hidden md:block'>
          <p className='text-sm md:text-base'>{t('no_products_key')}</p>
          <p className='text-sm font-semibold md:text-base'>
            {handleQtyText(order?.total_qty_ordered, locale)}
          </p>
        </div>
        <div className='hidden md:block'>
          <p className='text-center'>{t('total_key')}</p>
          <p className='text-sm font-semibold md:text-base'>
            {order?.base_grand_total} SR
          </p>
        </div>
        <div className='absolute top-full right-0 rtl:right-auto rtl:left-0'>
          <span
            className={`inline-block w-28 rounded-bl-xl text-center text-white md:w-48 md:py-1 rtl:rounded-br-xl rtl:rounded-bl-none`}
            style={{ backgroundColor: orderStatusBg }}
          >
            {handleOrderStatus(order?.state, locale)?.text}
          </span>
        </div>
      </div>
      <div className='mt-4 rounded-b-lg bg-white p-4'>
        {items?.map((product, i) => (
          <ProductCard
            key={product?.entity_id || i}
            product={product}
            fromDetails={fromDetails}
            mage={mage}
          />
        ))}
      </div>
    </Wrapper>
  );
};

export default OrderCard;
